var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0617 6.5C19.2904 5.19523 18.2863 4 16.9617 4H6.03788C4.71323 4 3.70922 5.19523 3.93784 6.5",
    stroke: "#838FB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 4C17.0281 3.74092 17.0423 3.61135 17.0425 3.50435C17.0448 2.48072 16.2737 1.62064 15.2559 1.51142C15.1495 1.5 15.0192 1.5 14.7586 1.5H8.24074C7.9801 1.5 7.84977 1.5 7.74337 1.51142C6.72559 1.62064 5.95456 2.48072 5.95679 3.50434C5.95702 3.61135 5.97121 3.7409 5.99958 4",
    stroke: "#838FB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4998 17.5H8.49976",
    stroke: "#838FB4",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88351 13.293C1.43748 10.1294 1.21447 8.54765 2.16232 7.52383C3.11017 6.5 4.79758 6.5 8.17239 6.5H14.8276C18.2024 6.5 19.8898 6.5 20.8377 7.52383C21.7855 8.54765 21.5625 10.1294 21.1165 13.293L20.6935 16.293C20.3437 18.7739 20.1689 20.0143 19.2717 20.7572C18.3745 21.5 17.0512 21.5 14.4046 21.5H8.59536C5.94881 21.5 4.62553 21.5 3.72834 20.7572C2.83115 20.0143 2.65626 18.7739 2.30648 16.293L1.88351 13.293Z",
    stroke: "#838FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.5a876ad1667397f7b17183b1cad685af.svg";
export { ForwardRef as ReactComponent };